import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  withStyles,
} from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';

const styles = theme => ({
  dialog: {
    padding: 0,
  },
});

const GeneratedPasswordDialog = ({ classes, open, password, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(password).then(() => setCopied(true));
  };

  const handleClose = () => {
    setCopied(false);
    onClose();
  };

  return (
    <Dialog className={classes.dialog} onClose={handleClose} open={open} maxWidth="xs" fullWidth>
      <DialogTitle style={{ padding: '20px 24px 7px' }}>Contraseña generada</DialogTitle>
      <DialogContent>
        <Typography>
          Esta contraseña solo se muestra una vez. Copiela y entréguesela al usuario.
        </Typography>
        <TextField
          value={password}
          margin="normal"
          fullWidth
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleCopy}>
                  <FileCopy />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {copied && (
          <Typography variant="caption" style={{ color: 'green' }}>
            Contraseña copiada al portapapeles
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(GeneratedPasswordDialog);
